import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';

export default function ChartTooltip({ label, value, detail, color = '#1689ff' }) {
  const dark = useTheme().palette.mode === 'dark';
  return <Box sx={{ bgcolor: dark ? '#151e42' : '#fff', color: dark ? '#f2f6ff' : '#101d3a', border: `1px solid ${dark ? '#34466c' : '#dce7f7'}`, borderLeft: `4px solid ${color}`, borderRadius: '10px', p: 1.5, minWidth: 155, boxShadow: '0 8px 28px #10204a24', pointerEvents: 'none' }}>
    <Typography sx={{ color: 'inherit', fontSize: '0.78rem', fontWeight: 650 }}>{label}</Typography>
    <Typography sx={{ color: 'inherit', fontSize: '1.2rem', fontWeight: 800, fontVariantNumeric: 'tabular-nums', my: 0.3 }}>{value}</Typography>
    {detail && <Typography sx={{ color: dark ? '#bdcce9' : '#465b7d', fontSize: '0.74rem' }}>{detail}</Typography>}
  </Box>;
}
